/* tslint:disable */
/* eslint-disable */
/**
 * STRY API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VideoEventPostBody
 */
export interface VideoEventPostBody {
    /**
     * id of video which was watched.
     * @type {number}
     * @memberof VideoEventPostBody
     */
    videoId?: number;
    /**
     * integer number of seconds watched (round half even)
     * @type {number}
     * @memberof VideoEventPostBody
     */
    secondsWatched?: number;
    /**
     * ISO-8601 local time at which client reports the video was closed (event completed).
     * @type {string}
     * @memberof VideoEventPostBody
     */
    completedAt?: string;
}

export function VideoEventPostBodyFromJSON(json: any): VideoEventPostBody {
    return VideoEventPostBodyFromJSONTyped(json, false);
}

export function VideoEventPostBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): VideoEventPostBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'videoId': !exists(json, 'video-id') ? undefined : json['video-id'],
        'secondsWatched': !exists(json, 'seconds-watched') ? undefined : json['seconds-watched'],
        'completedAt': !exists(json, 'completed-at') ? undefined : json['completed-at'],
    };
}

export function VideoEventPostBodyToJSON(value?: VideoEventPostBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'video-id': value.videoId,
        'seconds-watched': value.secondsWatched,
        'completed-at': value.completedAt,
    };
}


